import { Box, Container, Typography } from "@mui/material";
import { SectionHeading } from "../../../components/SectionHeading";
import { displayFont } from "../../../styles/theme";

const eventTypes = [
  {
    title: "Casamentos",
    description: "Da cerimônia à pista de dança, trilha sonora ao vivo para cada momento do grande dia.",
  },
  {
    title: "Eventos corporativos",
    description: "Música elegante para recepções, confraternizações e lançamentos, no tom certo para a sua marca.",
  },
  {
    title: "Festas e celebrações",
    description: "Aniversários, bodas e festas particulares com a energia de uma banda ao vivo.",
  },
];

export function EventTypes() {
  return (
    <Box component="section" sx={{ py: { xs: 10, md: 16 }, bgcolor: "#101010" }}>
      <Container maxWidth="lg">
        <SectionHeading
          overline="Eventos"
          title="Música ao vivo para cada celebração"
          subtitle="Uma apresentação pensada para o clima do seu evento."
        />

        <Box
          sx={{
            display: "grid",
            gap: 3,
            gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
          }}
        >
          {eventTypes.map(({ title, description }, index) => (
            <Box
              key={title}
              sx={{
                p: { xs: 4, md: 5 },
                borderRadius: 4,
                border: "1px solid",
                borderColor: "divider",
                bgcolor: "rgba(255, 255, 255, 0.02)",
                transition: "border-color 0.3s ease, transform 0.3s ease",
                "&:hover": { borderColor: "primary.main", transform: "translateY(-4px)" },
              }}
            >
              <Typography sx={{ fontFamily: displayFont, fontSize: 40, color: "primary.main", lineHeight: 1 }}>
                {String(index + 1).padStart(2, "0")}
              </Typography>
              <Typography variant="h3" sx={{ mt: 3, fontSize: { xs: "1.5rem", md: "1.75rem" } }}>
                {title}
              </Typography>
              <Typography sx={{ mt: 1.5, color: "text.secondary", lineHeight: 1.7 }}>{description}</Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
